export default {
  headerContent: {
    title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Turkiye Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'Turkiye Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sağlık sigortası, seyahat ederken size gönül rahatlığı sunar. Güvenebileceğiniz seyahat sağlık sigortası, yaralanmanız veya hastalanmanız durumunda da size hızlı acil tedavi sağlar.',
        'Seyahate çıkmadan önce seyahat sigortanızı yaptırarak, hayatınızı ve seyahatlerinizi biraz daha kolaylaştırmanıza yardımcı olacak çeşitli avantajlar ve hizmetler alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Kapsamı Nedir?',
      content: [
        {
          paragraph:
            'Poliçe kapsamında sunulan teminatlar planlara göre farklılık gösterebilir.',
          subList: null
        },
        {
          paragraph: '<strong><u>Yurt Dışı Teminatlar:</u></strong>',
          subList: [
            'Ani rahatsızlık ve hastalıklara ilişkin tıbbi tedavi teminatı',
            'Sigortalının tedavinin verilebileceği en yakın sağlık kuruluşuna seyahati veya nakli',
            'Vefat eden sigortalının cenaze nakli',
            'Sigortalının taburcu olduktan sonra ikametgah adresine nakli',
            'Sigortalıya yapılacak tedavi nedeniyle aile üyelerinden birinin konaklaması',
            'Tıbbi Danışmanlık',
            'Acil mesajların iletilmesi',
            'Bagaj kaybı veya hasarı',
            'Kanuni işlemlerle ilgili kefalet (Borç olarak)',
            'İlaç gönderilmesi organizasyonu'
          ]
        },
        {
          paragraph: '<strong><u>Yurt İçi Teminatlar:</u></strong>',
          subList: [
            'Ani rahatsızlık ve hastalıklara ilişkin tıbbi tedavi teminatı',
            'Sigortalının tedavinin verilebileceği en yakın sağlık kuruluşuna seyahati veya nakli',
            'Sigortalının taburcu olduktan sonra ikametgah adresine nakli',
            'Bagaj kaybı veya hasarı',
            'Vefat eden sigortalının cenaze nakli'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Turkiye Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Planları Nelerdir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta’nın hazırlamış olduğu seyahat sağlık sigortası planları:',
          subList: [
            'COVID-19 Turist Sigortası',
            'COVID-19 Konaklama Destek Sigortası',
            'Seyahat Sağlık Sigortası',
            'Yabancı Uyruklular Sağlık Sigortasıdır.'
          ]
        }
      ]
    },
    {
      title:
        'Turkiye Sigorta Seyahat Sağlık Sigortası Yardımcı Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'TABLO',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta COVID-19 Turist Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Sigortalının seyahat süresine bağlı olarak maksimum 30 güne kadar yapılabilen Covid-19 Turist Sigortası, koronavirüs hastalığı tanısı sebebiyle sigortalının hastanede alacağı tedavi süresi boyunca masrafların karşılanmasını sağlar.',
          subList: null
        },
        {
          paragraph:
            '** Covid-19 Turist Koruma ve Destek Sigortası’nda herhangi bekleme süresi bulunmamaktadır.',
          subList: null
        },
        {
          paragraph:
            '**Bu ürünü 0-65 yaş aralığında olan adaylar satın alabilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Turkiye Sigorta Seyahat Sağlık Sigortası Ne Zaman Başlar ve Biter?',
      content: [
        {
          paragraph:
            'Covid-19 (koronavirüs) hastalığına bağlı olarak kamu pandemi hastaneleri tarafından otelde karantinada tutulması kararı verilmesi halinde otelde ekstra konaklama gereksimi doğması durumunda seçilen paket teminatı kapsamında günlük tazminat bedeli sigortalıya ödenir.',
          subList: null
        },
        {
          paragraph:
            '** Bu poliçe Yabancı Turistin konaklamasının başından itibaren Safe Turizm sertifikalı otellerde konaklaması şartı ile geçerlidir.',
          subList: null
        },
        {
          paragraph:
            '**Bu ürünü 0-65 yaş aralığında olan adaylar satın alabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Yabancı Uyruklular Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Yabancıların ülkemizde ikamet edebilmesi için zorunlu olan özel sağlık sigortası güvence kapsamında yer alan teminatları ile sigortalıya avantaj sunar.',
          subList: null
        },
        {
          paragraph: 'Yatarak ve ayakta tedavi teminatları bulunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Yabancı uyruklu sağlık sigortası 1 yıllık yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Yabancı Uyruklu Sağlık Sigortası Yatarak Tedavi Teminatı Kapsamı Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Hastane hizmetleri (Ameliyat, ameliyathane, anestezi, ilaç, laboratuvar, radyoloji vb.)',
            'Hastanede kalınan süre içerisinde oda, yatak, yemek ve refakatçi masrafları',
            'Kornea, böbrek, pankreas, karaciğer, kalp, akciğer nakli',
            'ESWL, Gama Knife giderleri',
            'Koroner anjiyografi',
            'Yatarak tedavi esnasında yapılan tüm tanı amaçlı biyokimya, mikrobiyoloji, patoloji tetkikleri, radyolojik inceleme ve görüntüleme',
            'Ameliyat sonrası fizik tedavi',
            'Sigortalının günlük yaşam faaliyetlerine yardımcı olan ve sosyal bakımdan destek olunması amacıyla evde yapılan tıbbi bakım hizmetleri',
            'Kemoterapi, radyoterapi, diyaliz',
            'Besin zehirlenmesi, alçı uygulaması, basit yanık tedavileri gibi 24 saatten kısa sureli tıbbi tedaviler (gözlem, müşahede)',
            'Bir kaza veya hastalık sonucunda uzuv kaybı olması halinde suni uzuv giderleri',
            'Yoğun bakım ünitelerindeki tedaviler',
            'Trafik kazası sonucu meydana gelen diş ve burun ile ilgili tedaviler'
          ]
        },
        {
          paragraph:
            '** Ayakta tedavi giderleri yıllık 2.000 TL limit ve %40 sigortalı katılım payı ile karşılanır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Yabancı Uyruklu Sağlık Sigortası Yatarak Tedavi Teminatı Kapsamı Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Doktor muayene',
            'Tanı amaçlı incelemeler',
            'İlaç',
            'Fizik tedavi'
          ]
        },
        {
          paragraph:
            '** Türkiye Sigorta’nın tüm anlaşmalı sağlık kurumlarında yatarak tedavi giderleri limitsiz, anlaşmalı olmayan sağlık kurumlarında ise yıllık 20.000 TL limit ve %20 sigortalı katılım payı ile karşılanmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Seyahat Sağlık Sigortasını Neden Satın Almalıyım?',
      content: [
        {
          paragraph: null,
          subList: [
            'Schengen ve Dünya ülkelerine gidiş için vize işlemlerinde gereklidir.',
            'Yurt dışına yapmayı planladığınız seyahatlerde karşılaşabileceğiniz acil durumlarda sizi güvence alır.',
            'Seyahat sağlık sigortası yurt dışına çıkışlarda en önemli gereklerden biridir. ',
            'Yurt dışında bulunurken hastalık veya kaza halinde acil tıbbi yardım hizmetlerinin yanı sıra tedavi giderlerinin karşılanmasını da sağlanır. ',
            'Schengen ülkelerine vize için gerekli bir sigortadır.'
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Seyahat Sağlık Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta’nın seyahat sağlık sigortası ürününü herkes yaptırabilir. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Seyahat Sağlık Sigortası Ne Zaman Başlar ve Biter?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası poliçe başlangıç ve bitiş tarihleri poliçede yazmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Ne Zaman Yapılmalıdır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası mutlaka seyahat başlamadan önce yapılmalıdır. Seyahat başladıktan sonra poliçe düzenlenemez, düzenlenmiş poliçede plan değişikliği yapılamaz veya süre uzatımı istenemez. ',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta’nın seyahat sağlık sigortası planlarından yararlanmak isteyen tüm müşterilerimiz online teklif formunu doldurarak, fiyat talebinde bulunabilir ve poliçelerini satın alabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Kaç Gün Geçerlidir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası poliçe başlangıç ve bitiş tarihleri arasında geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Covid-19’U Karşılar Mı?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta’nın covid-19 teminatı sunan seyahat sağlık sigortası bulunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Seyahat Sağlık Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası hesaplaması seyahat edilecek ülke bilgileri, seyahat süresi ve sigortalanmak isteyen kişinin bilgileri doğrultusunda hesaplanmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası iptali poliçe başlamadan en geç bir gün önce yapılabilmektedir. Poliçe başlamadan önce sigorta satın almış olduğunuz firmayı arayarak iptalini talep edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Seyahat Sağlık Sigortası Ücretleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası sigortalı bilgileri ve poliçe kapsamına göre belirlenmektedir. En doğru prime ulaşmak için teklif almanız gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Fiyatı Ne Kadar?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası fiyatları; plana, sigortalı bilgilerine, seyahat edilecek ülkeye ve sigorta süresine göre değişmektedir. İhtiyaçlarınızı kapsayan planı bulmak için fiyat teklif talebini doldurabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
